import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";
import { translations } from "@/i18n/translations";
import AppStoreBadges from "@/components/AppStoreBadges";

// The hero image is served from /public (not bundled) so index.html can preload it
// at a stable URL before the JS bundle is parsed. Variants are generated by
// scripts/optimize-images.ts output in public/hero/.
const HeroSection = () => {
  const { t, localePath } = useLanguage();
  const s = t(translations.hero);

  return (
    <section className="relative bg-primary overflow-hidden py-14 md:py-28">
      {/* Diagonal accent */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-[hsl(358,82%,40%)]" />
      <div className="absolute bottom-0 left-0 right-0 h-16 md:h-24 bg-background [clip-path:polygon(0_100%,100%_0,100%_100%)]" />

      <div className="container mx-auto px-5 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* Image - show first on mobile for visual impact */}
          <div className="flex-1 flex justify-center order-first md:order-last animate-in fade-in zoom-in-95 duration-700">
            <picture>
              <source
                type="image/avif"
                srcSet="/hero/hero-boxes-480.avif 480w, /hero/hero-boxes-768.avif 768w, /hero/hero-boxes-1024.avif 1024w"
                sizes="(max-width: 767px) 192px, (max-width: 1024px) 512px, 1024px"
              />
              <source
                type="image/webp"
                srcSet="/hero/hero-boxes-480.webp 480w, /hero/hero-boxes-768.webp 768w, /hero/hero-boxes-1024.webp 1024w"
                sizes="(max-width: 767px) 192px, (max-width: 1024px) 512px, 1024px"
              />
              <img
                src="/hero/hero-boxes-768.png"
                alt=""
                width={1024}
                height={682}
                fetchPriority="high"
                decoding="async"
                className="w-48 md:w-full max-w-sm md:max-w-lg h-auto [filter:drop-shadow(0_20px_40px_rgba(0,0,0,0.35))]"
              />
            </picture>
          </div>

          {/* Text */}
          <div className="flex-1 space-y-5 md:space-y-6 text-center md:text-start text-primary-foreground animate-in fade-in slide-in-from-bottom-6 duration-700">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight">
              {s.title1}<br />
              {s.title2}
            </h1>
            <p className="text-xs md:text-base max-w-md mx-auto md:mx-0">
              {s.subtitle}
            </p>
            <div>
              <Button
                size="lg"
                variant="secondary"
                className="rounded-md px-8 md:px-10 py-5 md:py-6 text-base md:text-lg font-bold text-primary"
                asChild
              >
                <Link to={localePath("/sell/register")}>{s.cta}</Link>
              </Button>
            </div>
            <AppStoreBadges />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
